// pages/UserManagement.jsx
import axios from "axios";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoaderCircle } from "lucide-react";

const ROLES = ["admin", "manager", "viewer"];

const UserManagement = () => {
  const [users, setUsers] = useState([]);

  const { isLoading: loading } = useQuery({
    queryKey: ["users-management"],
    queryFn: async () => {
      const res = await axios.get("https://dummyjson.com/users?limit=10");
      const data = res.data;

      // Add role locally
      const usersWithRoles = data.users.map((u) => ({
        ...u,
        role: "viewer",
      }));

      setUsers(usersWithRoles);
      return usersWithRoles;
    },
  });

  const handleRoleChange = (id, newRole) => {
    setUsers((prev) =>
      prev.map((user) => (user.id === id ? { ...user, role: newRole } : user)),
    );

    toast.success("Role updated successfully");
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md">
      <h2 className="text-xl font-semibold mb-4">User Management</h2>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-left">Role</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="3" className="p-4 text-center">
                  <LoaderCircle className="h-6 w-6 mx-auto animate-spin" />
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user.id} className="border-b">
                  <td className="p-3">
                    {user.firstName} {user.lastName}
                  </td>
                  <td className="p-3">{user.email}</td>
                  <td className="p-3">
                    <select
                      value={user.role}
                      onChange={(e) =>
                        handleRoleChange(user.id, e.target.value)
                      }
                      className="w-full border rounded-md px-3 py-2
                       transition-all duration-200 ease-out
                        focus:outline-none
                      focus:border-black
                         focus:ring-1 focus:ring-black
                          focus:scale-[1.02]"
                    >
                      {ROLES.map((role) => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserManagement;
